import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Result } from "antd";
import { useLocation } from "react-router-dom";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
const SignIn = () => {
	const { instance } = useMsal();
	const { pathname } = useLocation();

	useEffect(() => {
		window.localStorage.setItem("redirectUrl", pathname);
		if (instance)
			instance.loginRedirect(loginRequest).catch((e) => {
				console.log(e);
			});
	}, [pathname, instance]);
	return (
		<Result title="Sign In">Redirecting you to the sign-in page...</Result>
	);
};

export default SignIn;
